import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axiosInstance";

export const gstApi = createAsyncThunk("gst", async () => {
  const response = await axiosInstance.get(`/gst/get`);
  return response.data;
});

const gstSlice = createSlice({
  name: "gst",
  initialState: {
    gst: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(gstApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(gstApi.fulfilled, (state, action) => {
        state.gst = action.payload;
        state.loading = false;
      })
      .addCase(gstApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default gstSlice.reducer;
